/* eslint-disable react/jsx-no-bind */
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as trackActions from '../../actions/trackActions';
import * as videoActions from '../../actions/videoActions';

class TurnMeUp extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.increaseDecreaseRating = this.increaseDecreaseRating.bind(this);
        const settings = this.getSettings(this.props);
        this.state = {
            turnedUp: settings.turnedUp, 
            clickEnabled: settings.clickEnabled,
            tooltipText: settings.tooltipText,
            loading: false,
            rating: props.rating
        };
    }

    componentDidMount() {  
        const control = $(this.control);
        //for some reason, this isn't getting set automatically when loaded from some places
        control.attr('title', this.state.tooltipText);
        if(this.state.turnedUp) {
            control.addClass('btn-active');
        }
        else {
            control.removeClass('btn-active');
        }
        $(this.control).tooltip();
    }

    componentWillUpdate(nextProps, nextState) {
        if(nextProps.user !== this.props.user || nextProps.activeProfile !== this.props.activeProfile) {
            const settings = this.getSettings(nextProps);
            this.setState({
                turnedUp: settings.turnedUp, 
                clickEnabled: settings.clickEnabled,
                tooltipText: settings.tooltipText
            });
        }
        if(nextProps.rating !== this.props.rating) {
            this.setState({ rating: nextProps.rating });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevState.tooltipText !== this.state.tooltipText) {
            const control = $(this.control);
            //remove the default title element and update the text of the bootstrap tooltip
            control.attr('data-original-title', this.state.tooltipText);
            control.removeAttr('title');
            //if the tooltip is visible, change the visible text
            control.next().find('.tooltip-inner').text(this.state.tooltipText);
            //control.attr('title', nextState.tooltipText);
            if(this.state.turnedUp) {
                control.addClass('btn-active');
            }
            else {
                control.removeClass('btn-active');
            }
        }
    }

    getSettings(props) {
        const {id, roleID, user, activeProfile, isMusic} = props; 
        let turnedUp = false;
        let clickEnabled = false;
        let tooltipText = '';
    
        if(!user) {
            clickEnabled = false;
            tooltipText = "Log in to turn me up!";
        }
        else if(!activeProfile) {
            clickEnabled = false;
            tooltipText = "Create a profile to turn me up!";
        }
        else if(!user.Confirmed) {
            clickEnabled = false;
            tooltipText = "Please confirm your email address to turn me up!";
        }
        else
        {
            turnedUp = activeProfile.Ratings.includes(id);
    
            if(user.enabledProfiles.find(p => p.ID === roleID)) {
                clickEnabled = false;
                tooltipText = `You cannot rate your own ${isMusic ? 'track' : 'video'}`;
            }
            else if (turnedUp) {
                tooltipText = "CANCEL TURN ME UP";
                clickEnabled = true;
            }
            else {
                tooltipText = "LIKE ME?";
                clickEnabled = true;
            }
        }
        return { turnedUp, clickEnabled, tooltipText };
    }

    increaseDecreaseRating(event, clickEnabled, turnedUp) {
        event.preventDefault();
        const id = this.props.id;
        const activeProfile = this.props.activeProfile;
        this.setState({ loading: true, clickEnabled: false });
        if(clickEnabled) {
            let action;
            if(this.props.isMusic) {
                if(!turnedUp) {
                    action = this.props.actions.increaseTrackRating;
                }
                else {
                    action = this.props.actions.decreaseTrackRating;
                }
            }
            else {
                if(!turnedUp) {
                    action = this.props.actions.increaseVideoRating;
                }
                else {
                    action = this.props.actions.decreaseVideoRating;
                }
            }
            action(id, activeProfile.ID)
                .then(rating => {
                    this.setState({ rating: rating.Rating, loading: false, clickEnabled: true });
                })
                .catch(error => {
                    this.setState({ loading: false, clickEnabled: true });
                });
        }
    }

    render() {
        const { turnedUp, clickEnabled, tooltipText, rating } = this.state;        
    
        return (
            <a className={`btn-loudupnew transition tip loudboxnew ${turnedUp ? 'btn-active' : ''}`} href="#" ref={(control) => this.control = control} data-toggle="tooltip" data-placement="top" title={tooltipText} onClick={(event) => this.increaseDecreaseRating(event, clickEnabled, turnedUp)} style={{cursor: 'pointer'}}>
                <span className="btnbody">
                    <span className="up">
                        <svg className="icon icn-loudup transition">
                            <use  xlinkHref="#icn-loudup" />
                        </svg>
                    </span>
                    Turn Me Up!
                </span>
                <span className="ups loudrating">{rating}<span className="db">dB</span></span>
            </a>
        );
    }
}

TurnMeUp.propTypes = {
    id: PropTypes.number,
    actions: PropTypes.object.isRequired,
    rating: PropTypes.number.isRequired,
    isMusic: PropTypes.bool,
    user: PropTypes.object,
    activeProfile: PropTypes.object,
    roleID: PropTypes.number.isRequired
};

function mapStateToProps(state, ownProps) {
    return { 
        user: state.account.user,
        activeProfile: state.account.user ? state.account.user.activeProfile : null
    };
}

function mapDispatchToProps(dispatch) {
    return {
        //track actions will now be available under this.props.actions
        actions: bindActionCreators(Object.assign({}, trackActions, videoActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TurnMeUp);